import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'Components/UI/Button';
import { Container } from './styles';

import emptyImg from 'Static/images/empty-notification.png';

interface IEmpty {
  onRedirect: (url: string) => void;
}

const Empty: FC<IEmpty> = ({ onRedirect }) => {
  const { t } = useTranslation('notification');

  return (
    <Container>
      <img src={emptyImg} alt={t('widget.empty.imgAlt')} />
      <span className="title">{t('widget.empty.title')}</span>
      <span className="description">
        {t('widget.empty.description')}
      </span>
      <Button
        type="primary"
        className="button"
        onClick={() => onRedirect('/notification')}
      >
        {t('widget.viewAll')}
      </Button>
    </Container>
  )
}

export default Empty;
